import './style.sass';

import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

const Review : React.FC = () => {
    return (
        <div className="aimed-review">
            <FullWrapper>
                <div className="aimed-reviewWrapper">
                    <div className="aimed-reviewTitle">Клиент о нас</div>
                    <div className="aimed-reviewMiddle">
                        <div className="aimed-reviewParagraf">
                            С&nbsp;командой &laquo;Вебпрактик&raquo; сотрудничаем уже
                            не&nbsp;в&nbsp;первый раз. Каждый наш совместный проект обладает
                            уникальными особенностями. Разработка платформы для проведения конкурса
                            AI&rsquo;m Doctor не&nbsp;является исключением. Это масштабный
                            и&nbsp;технически сложный проект, который должен учитывать медицинскую
                            специфику.
                        </div>
                        <div className="aimed-reviewParagraf">
                            Наш партнер подошел к&nbsp;вопросу реализации платформы с&nbsp;особой
                            тщательностью, вниманием к&nbsp;деталям и&nbsp;открытостью
                            к&nbsp;обратной связи на&nbsp;протяжении всего процесса разработки. При
                            проектировании новой платформы &laquo;Вебпрактик&raquo; учли опыт
                            разработки платформы для конкурса ПРО//ЧТЕНИЕ: команда помогла нам
                            с&nbsp;экспертизой в&nbsp;проектировании архитектуры, разработке новых
                            утилит и&nbsp;формировании датасетов. Спасибо команде
                            &laquo;Вебпрактик&raquo; за&nbsp;профессиональный подход к&nbsp;решению
                            технологически сложных задач!<span>»</span>
                        </div>
                    </div>
                    <div className="aimed-reviewBottom">
                        <div className="aimed-reviewBottomInfo">
                            <div className="aimed-reviewBottomAuthor">
                                Команда Технологических конкурсов НТИ Up&nbsp;Great
                            </div>
                        </div>
                        <img src='/images/svg/aimed/fond.svg' alt="reviewLogo" className="aimed-reviewBottomLogo" />
                    </div>
                </div>
            </FullWrapper>
        </div>
    );
};

export default Review;
